// Utilidades para notificaciones del navegador

let notificationPermission = null;

/**
 * Solicita permiso para mostrar notificaciones
 */
export async function requestNotificationPermission() {
  if (!('Notification' in window)) {
    console.log('Este navegador no soporta notificaciones');
    return false;
  }

  if (Notification.permission === 'granted') {
    return true;
  }

  if (Notification.permission !== 'denied') {
    const permission = await Notification.requestPermission();
    return permission === 'granted';
  }

  return false;
}

/**
 * Muestra una notificación del navegador
 */
export function showNotification(title, options = {}) {
  if (!('Notification' in window)) {
    return null;
  }

  if (Notification.permission === 'granted') {
    const notification = new Notification(title, {
      icon: '/favicon.ico',
      badge: '/favicon.ico',
      tag: options.tag || 'whatsapp-message',
      requireInteraction: false,
      silent: false,
      ...options
    });

    // Cerrar la notificación después de 5 segundos
    setTimeout(() => {
      notification.close();
    }, 5000);

    // Cuando se hace clic en la notificación, enfocar la ventana
    notification.onclick = () => {
      window.focus();
      notification.close();
    };

    return notification;
  }

  return null;
}

/**
 * Reproduce un sonido de notificación
 */
export function playNotificationSound() {
  try {
    // Crear un audio context para generar un sonido simple
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    const oscillator = audioContext.createOscillator();
    const gainNode = audioContext.createGain();

    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);

    oscillator.frequency.value = 800; // Frecuencia del tono
    oscillator.type = 'sine';

    gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
    gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.5);

    oscillator.start(audioContext.currentTime);
    oscillator.stop(audioContext.currentTime + 0.5);
  } catch (error) {
    console.log('No se pudo reproducir sonido de notificación:', error);
  }
}

/**
 * Actualiza el título de la pestaña con contador de mensajes
 */
export function updateTabTitle(unreadCount) {
  if (unreadCount > 0) {
    document.title = `(${unreadCount}) WhatsApp Business Panel`;
  } else {
    document.title = 'WhatsApp Business Panel';
  }
}








